import { Environment } from "./model";

export const environment: Environment = {
  production: false,
  local: false,
  api: {
    url: 'https://api-dev-terminal.tradersdiaries.com/',
  },
  app: {
    url: 'https://dev-terminal.tradersdiaries.com/',
  },
  diary: {
    url: 'https://dev.tradersdiaries.com/diary/',
  },
  langs: ['en','ru'],
  idSystem: {
    apiUrl: 'https://id-api-dev.tradersdiaries.com',
    clientId: 'webcscalp_dev',
    url: 'https://id-dev.tradersdiaries.com',
  },
  /*keycloak: {
    url: 'https://auth-dev.fsr-develop.com',
    realm: 'main',
    clientId: 'tradersdiaries-front-app-dev',
  },*/
  ymCounterId: 0,
}
